<mat-tab-group #tabGroup class="company-chart-tabs" (selectedTabChange)="onTabChanged($event);" animationDuration="0ms">
  <mat-tab label="BOARD INFLUENCE">

    <ng-template mat-tab-label>
      <label>BOARD INFLUENCE <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.chart_board_influence" #tt_chart_board_influence="matTooltip" (click)="tt_chart_board_influence.toggle()"></i></label>
    </ng-template>
    <ng-template matTabContent>
      <div class="chart-container" [ngClass]="{'blurred-strong': company.is_premium}">
        <canvas baseChart class="chart"
                [data]="pieChartData"
                [options]="pieChartOptions"
                [plugins]="pieChartPlugins"
                [type]="pieChartType">
        </canvas>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="BOARD PERFORMANCE" style="height: 900px">
    <ng-template mat-tab-label>
      <label>BOARD PERFORMANCE <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.chart_board_performance" #tt_chart_board_performance="matTooltip" (click)="tt_chart_board_performance.toggle()"></i></label>
    </ng-template>
    <ng-template matTabContent>
      <div class="chart-container" [ngClass]="{'blurred-strong': company.is_premium}">
        <canvas baseChart class="chart"
                [data]="barChartData"
                [options]="barChartOptions"
                [plugins]="barChartPlugins"
                [type]="barChartType">
        </canvas>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="NETWORK" class="fw-bold">
    <ng-template mat-tab-label>
      <label>NETWORK <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.chart_network" #tt_chart_network="matTooltip" (click)="tt_chart_network.toggle()"></i></label>
    </ng-template>
    <ng-template matTabContent>
      <div class="chart-container" [ngClass]="{'blurred-strong': company.is_premium}">
        <canvas baseChart class="chart" *ngIf="pyramidChartData"
                [data]="pyramidChartData"
                [options]="pyramidChartOptions"
                [plugins]="pyramidChartPlugins"
                [type]="pyramidChartType">
        </canvas>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
